/* eslint-disable */
import React from 'react';
import PageTitle from '../components/Text/PageTitle';

function TermsAndConditions() {
  return (
    <section className="hero section section__wide">
      <PageTitle>Terms and conditions</PageTitle>
      <p>DATE OF LAST REVISION: 24 March 2023</p> <br />
      <p>
        These terms and conditions outline the rules and regulations for the use
        of Shajar' Website, located at shajarthecompany.com/. By accessing this
        website, you agree to these terms and conditions. Please do not continue
        to use shajarthecompany.com/ if you do not agree with all of the terms
        and conditions stated on this page. The following terminology applies to
        these Terms and Conditions, Privacy Statement and Disclaimer Notice and
        all Agreements: “Client”, “You” and “Your” refers to you, the person log
        on this website and compliant to the Company’s terms and conditions.
        “The Company”, “Ourselves”, “We”, “Our” and “Us”, refers to our Company.
        “Party”, “Parties”, or “Us”, refers to both the Client and ourselves.
      </p>{' '}
      <p>
        All terms refer to the offer, acceptance and consideration of payment
        necessary to undertake the process of our assistance to the Client in
        the most appropriate manner for the express purpose of meeting the
        Client’s needs in respect of provision of the Company’s stated services,
        in accordance with and subject to, prevailing law of United States. Any
        use of the above terminology or other words in the singular, plural,
        capitalization and/or he/she or they, are taken as interchangeable and
        therefore as referring to same. Cookies We employ the use of cookies. By
        accessing shajarthecompany.com/, you agree to use cookies in agreement
        with the Shajar' Terms and Conditions and Privacy Policy. Most
        interactive websites use cookies to let us retrieve the user’s details
        for each visit. In order to provide you with access to the Website and a
        more personalized and responsive service, we need to remember and store
        information about how you use this website. This is done using small
        text files called cookies. Cookies contain small amounts of information
        and are downloaded to your computer or another device by a server for
        this Website. Your web browser then sends these cookies back to this
        website on each subsequent visit so that it can derecognize and remember
        things like your user preferences (visits, clicks, historical activity).
        You can find more detailed information about cookies and how they work
        at http://www.aboutcookies.org. Cookies are used by our website to
        enable the functionality of certain areas to make it easier for people
        visiting our website. Some of our affiliate/advertising partners may
        also use cookies (necessary cookies).
      </p>{' '}
      <p>
        This site offers newsletter or email subscription services and cookies
        may be used to remember if you are already registered and whether to
        show certain notifications which might only be valid for
        subscribed/unsubscribed users. When you submit data through a form such
        as those found on contact pages or comment forms, cookies may be set to
        remember your user details for future correspondence (functional
        cookies). We also use social media buttons and/or plugins on this site
        that allow you to connect with your social network in various ways. For
        these to work social media sites such as Facebook, and LinkedIn, will
        set cookies through our site which may be used to enhance your profile
        on the respective site, or contribute to the data they hold for various
        purposes outlined in their respective privacy policies. We or our
        service providers also use analytic services to help us understand how
        effective our content is, what interests our users have, and to improve
        how this Website works. In addition, we use web beacons or tracking
        pixels to count visitor numbers and performance cookies to track how
        many individual users access this Website and how often. This
        information is used for statistical purposes only and it is not our
        intention to use such information to personally identify any user. The
        cookies collected are used to a very limited extent necessary for
        technical purposes (website functionality) and stored for 1 to 5 years
        in line with the international NAI standards. The browsers of most
        computers, smartphones, and other web-enabled devices are typically set
        up to accept cookies. If you wish to amend your cookie preferences for
        this website or any other websites you can do this through your browser
        settings. Your browser’s ‘help’ function will tell you how to do this.
      </p>{' '}
      <p>
        Be aware that disabling cookies will affect the functionality of this
        website in areas in which cookies are necessary for the functioning of
        features, and usually results in also disabling certain functionalities
        and features on this site. Therefore, it is recommended that you do not
        disable cookies. License and Intellectual Property Rights Unless
        otherwise stated, Shajar llc, and/or its licensors own the intellectual
        property rights for all material on shajarthecompany.com/. This website
        and its contents are protected by copyright, trademark, and other laws
        of United States, and/or foreign countries. We and our licensors reserve
        all rights not expressly granted under these Terms of Use. You may
        access this website for your own personal use subject to restrictions
        set in these terms and conditions. You must not: Republish material from
        shajarthecompany.com/; Use material from shajarthecompany.com/ for
        commercial purposes; Sell, rent, or sub-license material from
        shajarthecompany.com/; Reproduce, duplicate, modify or copy material
        from shajarthecompany.com/; Redistribute content from
        shajarthecompany.com/. You shall not use the "Shajar llc" name or the
        Shajar llc logo, either alone or in combination with other words or
        design elements. You may not use any of the foregoing names, marks, or
        logos in any press release, advertisement, or other promotional or
        marketing material or media, whether in written, oral, electronic,
        visual, or any other form, except if expressly permitted in writing by
        Shajar llc. You will comply with all applicable laws in accessing and
        using this Website. Your Privacy You acknowledge that we may use your
        personal information and data according to our Privacy Policy
        incorporated herein by this reference. You hereby agree to the terms of
        our Privacy Policy, including any obligations imposed on you therein.
      </p>{' '}
      <p>
        Reservation of Rights We reserve the right to request that you remove
        all links or any particular link to our website. You approve of
        immediately removing all links to our website upon request. We also
        reserve the right to amend these terms and conditions at any time. By
        linking to our website, you agree to be bound to and follow these terms
        and conditions. Removal of links from our website If you find any link
        on our website that is offensive for any reason, you are free to contact
        and inform us at any moment. We will consider requests to remove links,
        but we are not obligated to or so or to respond to you directly.
        Disclaimers and Limitations of Liability We do not ensure that the
        information on this website is correct, we do not warrant its
        completeness or accuracy; nor do we promise to ensure that the website
        remains available or that the material on the website is kept up to
        date. This website (including without limitation any content or other
        part thereof) contains general information only, and we are not, by
        means of this website, rendering professional advice or services. Before
        making any decision or taking any action that might affect your finances
        or business, you should consult a qualified professional advisor. This
        website is provided as is, and we make no express or implied
        representations or warranties regarding it. Without limiting the
        foregoing, we do not warrant that this website will be secure,
        error-free, free from viruses or malicious code, or will meet any
        particular criteria of performance or quality. We expressly disclaim all
        implied warranties, including, without limitation, warranties of
        merchantability, title, fitness for a particular purpose,
        non-infringement, compatibility, security, and accuracy. Your use of
        this website is at your own risk and you assume full responsibility and
        risk of loss resulting from your usage, including, without limitation,
        with respect to loss of service or data. We will not be liable for any
        direct, indirect, special, incidental, consequential, or punitive
        damages or any other damages whatsoever, whether in an action of
        contract, statute, tort (including, without limitation, negligence), or
        otherwise, relating to or arising out of the use of this website, even
        if we knew, or should have known, of the possibility of such damages.
      </p>{' '}
      <p>
        Certain links on this website may lead to websites, resources, or tools
        maintained by third parties over whom we have no control. The Terms and
        Conditions Generator helped us to generate our own set of documents.
        Without limiting any of the foregoing, we make no express or implied
        representations or warranties whatsoever regarding such websites,
        resources, and tools, and links to any such websites, resources and
        tools should not be construed as an endorsement of them or their content
        by us. The above disclaimers and limitations of liability shall be
        applicable not only to us but also to our personnel and subcontractors.
      </p>{' '}
      <p>
        The above disclaimers and limitations of liability are applicable to the
        fullest extent permitted by law, whether in contract, statute, tort
        (including, without limitation, negligence), or otherwise. To the
        maximum extent permitted by applicable law, we exclude all
        representations, warranties, and conditions relating to our website and
        the use of this website. As long as the website and the information and
        services on the website are provided free of charge, we will not be
        liable for any loss or damage of any nature.
      </p>
    </section>
  );
}

export default TermsAndConditions;
